<template>
    <div>
        <ProfileEditForm/>
    </div>
</template>

<script>
import ProfileEditForm from '../Profile/ProfileEditForm'

export default {
  name: 'ProfileEdit',

  components: {
    ProfileEditForm
  }
}
</script>
